const readBlob = async blob => {
  const fileReader = new FileReader()
  return new Promise((resolve, reject) => {
    fileReader.onerror = () => {
      fileReader.abort()
      reject(new Error('blob読み込み失敗'))
    }
    fileReader.onload = () => {
      resolve(fileReader.result)
    }
    fileReader.readAsText(blob)
  })
}

const blobToJson = async blob => {
  const blobText = await readBlob(blob)
  return JSON.parse(blobText)
}

export { blobToJson }
